import React, { useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { useApp } from "../context/AppContext";

const ContactForm = ({ resultContext }) => {
  const { t, language } = useApp();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) return;
    setSubmitting(true);
    try {
      await api.post("/leads", {
        name: name.trim(),
        phone: phone.trim(),
        language: language || "es",
        scenario: resultContext?.scenario || "unknown",
        inputs: resultContext?.inputs || {},
        projected_total: resultContext?.total || 0,
        membership_total: resultContext?.membershipTotal ?? null,
        savings: resultContext?.savings ?? null,
      });
      setSuccess(true);
      toast.success(t("contact_success"));
      setName("");
      setPhone("");
    } catch (err) {
      toast.error(t("contact_error"));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="ourigen-pattern py-20 sm:py-28" data-testid="contact-section">
      <div className="mx-auto max-w-2xl px-5 sm:px-8">
        <div className="text-center">
          <p className="text-xs tracking-luxury text-[#D4AF37]">
            {t("contact_eyebrow")}
          </p>
          <h2 className="mt-4 font-display text-3xl text-white sm:text-5xl">
            {t("contact_title")}
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-white/60 sm:text-base">
            {t("contact_subtitle")}
          </p>
        </div>

        <form
          onSubmit={submit}
          className="mt-10 border border-white/10 bg-[#131316]/90 p-6 backdrop-blur-md sm:p-12"
          data-testid="contact-form"
        >
          <div className="space-y-7">
            <div>
              <label className="block text-[10px] uppercase tracking-luxury text-white/50 sm:text-xs">
                {t("contact_name")}
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="mt-3 w-full border-0 border-b border-white/15 bg-transparent px-0 py-3 font-display text-xl text-white outline-none transition-colors focus:border-[#D4AF37] sm:text-2xl"
                data-testid="contact-name-input"
              />
            </div>
            <div>
              <label className="block text-[10px] uppercase tracking-luxury text-white/50 sm:text-xs">
                {t("contact_phone")}
              </label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
                className="mt-3 w-full border-0 border-b border-white/15 bg-transparent px-0 py-3 font-display text-xl text-white outline-none transition-colors focus:border-[#D4AF37] sm:text-2xl"
                data-testid="contact-phone-input"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="mt-10 w-full bg-[#D4AF37] px-10 py-5 text-xs font-bold uppercase tracking-luxury text-black transition-all duration-300 hover:bg-white disabled:opacity-50"
            data-testid="contact-submit-btn"
          >
            {submitting ? "..." : t("contact_cta")}
          </button>
          {success && (
            <p
              className="mt-6 text-center text-sm text-[#D4AF37]"
              data-testid="contact-success-msg"
            >
              ✓ {t("contact_success")}
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
